import { withNamespaces } from 'react-i18next';
import { memo, useEffect, useRef, useState } from 'react';
import { Nav, NavItem, NavLink } from 'reactstrap';
import { useHistory, useLocation } from 'react-router-dom';
import { connect } from "react-redux";
import PerfectScrollbar from 'react-perfect-scrollbar';
import { isFeatureEnabledForActiveModule } from 'src/helpers/module_helper';

const LoadingComponent = () => {
    return (
        <div style={{
            backgroundColor: '#D1D2D6'
        }}>
            <div>
                <Nav tabs className="custom-style-1">
                    <NavItem className='active'>
                        <NavLink className='active'>
                            <div className="dt-field dt-skeleton"></div>
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink>
                            <div className="dt-field dt-skeleton"></div>
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink>
                            <div className="dt-field dt-skeleton"></div>
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink>
                            <div className="dt-field dt-skeleton"></div>
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink>
                            <div className="dt-field dt-skeleton"></div>
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink>
                            <div className="dt-field dt-skeleton"></div>
                        </NavLink>
                    </NavItem>
                </Nav>
            </div>
        </div>
    )
}

const Tabs = memo(({
    t,
    modules,
    isLoading,
    onActiveTabChange,
    softwareData,
    user
}) => {
    const navBarRef = useRef();
    const scrollBarRef = useRef();
    const history = useHistory();
    const location = useLocation();
    const [activeTab, setActiveTab] = useState("");
    const [navbarWidth, setNavbarWidth] = useState('0px');
    const [tabsToShow, setTabsToShow] = useState([
        {
            key: "compliance",
            title: "Compliance",
            feature: "compliance_check"
        },
        {
            key: "basic-information",
            title: "Basic Information"
        },
        {
            key: "internal-comments",
            title: "Internal Comments"
        },
        {
            key: "processing-activity",
            title: "Processing Activity"
        },
        {
            key: "ai-risk-assessment",
            title: "AI Risk Assessment"
        },
        {
            key: "dpia",
            title: "DPIA"
        },
        {
            key: "monitoring",
            title: "Monitoring",
            feature: "news_monitoring"
        },
        {
            key: "related-incident",
            title: "Related Incidents"
        },

        {
            key: "risk-assessment",
            title: "Risk Assessment"
        },
        {
            key: "task-management",
            title: "Task Management"
        },
        {
            key: "dpa",
            title: "Data Protection Authority"
        },
        {
            key: "history-log",
            title: "History Log"
        }
    ]);

    const getNavWidth = () => {
        if (navBarRef && navBarRef.current) {
            return ((navBarRef.current.querySelector('.nav'))?.scrollWidth || 0) + 'px';
        }
        return '0px';
    }

    useEffect(() => {
        setActiveTab((new URLSearchParams(location.search)).get('tab'));
    }, [location.search]);

    useEffect(() => {
        if (!(new URLSearchParams(location.search)).get('tab')) {
            return history.push({
                search: '?tab=basic-information'
            })
        }

        const observer = new ResizeObserver(() => {
            if(scrollBarRef.current)
                scrollBarRef.current.updateScroll();
        });

        const el = window.document.querySelector('html');

        observer.observe(el)

        return () => {
            observer.unobserve(el)
        };
    }, []);

    useEffect(() => {
        if(!isLoading){
            requestAnimationFrame(() => {
                setNavbarWidth(getNavWidth());    
            });
        }
    }, [
        tabsToShow,
        isLoading
    ]);

    useEffect(() => {
        if (!isLoading && activeTab && tabsToShow.length > 0) {
            const tab = tabsToShow.find((tab) => tab.key === activeTab);

            if (tab) {
                onActiveTabChange && onActiveTabChange({ tab });
            }
            else {
                history.push({
                    search: `?tab=${tabsToShow[0].key}`
                });
            }
        }
    }, [
        activeTab,
        tabsToShow,
        isLoading
    ]);

    useEffect(() => {        
        if(modules.featuresLoadingStatus === 'loaded' && softwareData){
            setTabsToShow(prev =>
                prev.filter(tabItem =>
                    (!tabItem.feature || isFeatureEnabledForActiveModule(tabItem.feature)) 
                    // &&
                    // (tabItem.key !== 'ai-risk-assessment' || softwareData?.has_ai_risk_assessment)
                )
            );
        }
    }, [ 
        modules.featuresLoadingStatus,
        softwareData
    ]);

    if (modules.featuresLoadingStatus === 'loading' || isLoading || !user) {
        return (
            <LoadingComponent />
        )
    }

    const isActiveTab = (currentTab, tab) => currentTab === tab;

    return (
        <div style={{
            backgroundColor: '#D1D2D6'
        }}>
            <PerfectScrollbar ref={scrollBarRef}>
                <div ref={navBarRef} style={{
                    width: navbarWidth
                }}>
                    <Nav tabs className="custom-style-1">
                        {
                            tabsToShow.map((link) => {
                                return (
                                    <NavItem className={isActiveTab(activeTab, link.key) ? 'active' : ''} key={link.key}>
                                        <NavLink
                                            className={isActiveTab(activeTab, link.key) ? 'active' : ''}
                                            onClick={() => history.push({
                                                search: '?tab=' + link.key
                                            })}>
                                            {t(link.title)}
                                        </NavLink>
                                    </NavItem>
                                )
                            })
                        }
                    </Nav>
                </div>
            </PerfectScrollbar>
        </div>
    );
});

const mapStatetoProps = (state) => {
    const { Modules } = state;
    const { user } = state.Login;

    return {
        modules: Modules,
        user
    };
};

export default withNamespaces()(connect(
    mapStatetoProps,
    {}
)(Tabs));
